import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import TextButton from 'LuxKit/Button/TextButton'
import LineTrashAltIcon from 'LuxKit/Icons/line/LineTrashAltIcon'
import zIndex from 'styles/tools/z-index'
import LinePlusIcon from 'LuxKit/Icons/line/LinePlusIcon'
import { tileDesktopLayout } from './constants'
import Group from 'components/utils/Group'
import Counter, { CounterChangeEventHandler } from 'LuxKit/Counter'
import BodyText from 'LuxKit/Typography/BodyText'

// Can't use <Group /> as our 'breakpoints' are container queries, not screen sizes
const ActionsContainer = styled.div`
  display: flex;
  justify-content: start;
  gap: ${rem(8)};

  ${tileDesktopLayout} {
    flex-direction: column;
    justify-content: end;
  }
`

const ActionsRow = styled.div`
  z-index: ${zIndex.reviewCartButtons};
  display: flex;
  gap: ${rem(8)};

  ${tileDesktopLayout} {
    justify-content: end;
  }
`

interface Props {
  variant: App.MerchandiseOfferVariant
  itemCount: number
  saveForLater?: boolean
  onSaveForLater?: React.MouseEventHandler<HTMLButtonElement>
  onDelete?: React.MouseEventHandler<HTMLButtonElement>
  onAddItem?: () => void
  onRemoveItem?: () => void
}

function MerchandiseCartReviewTileActions({
  variant,
  itemCount,
  saveForLater,
  onSaveForLater,
  onDelete,
  onAddItem,
  onRemoveItem,
}: Props) {
  const isBookable = !!variant.inventory

  const onQuantityCounterChange = useCallback<CounterChangeEventHandler>((value, _, e) => {
    e.preventDefault()
    if (value > itemCount) {
      onAddItem?.()
    } else {
      onRemoveItem?.()
    }
  }, [onAddItem, onRemoveItem, itemCount])

  return <ActionsContainer>
    <ActionsRow>
      {isBookable && <>
        {!saveForLater && <TextButton
          kind="secondary"
          size="small"
          shape="round"
          onClick={onSaveForLater}
        >
          Save for later
        </TextButton>}
        {saveForLater && <TextButton
          kind="primary"
          size="small"
          shape="round"
          startIcon={<LinePlusIcon />}
          onClick={onSaveForLater}
        >
          Add
        </TextButton>}
      </>}
      <TextButton
        kind="secondary"
        size="small"
        shape="round"
        startIcon={<LineTrashAltIcon />}
        onClick={onDelete}
      >
        Delete
      </TextButton>
    </ActionsRow>
    {!!isBookable && <Group
      direction="horizontal"
      gap={8}
      verticalAlign="center"
      horizontalAlign="end"
    >
      <BodyText variant="small" weight="bold">Qty</BodyText>
      <Counter
        value={itemCount}
        onChange={onQuantityCounterChange}
        min={1}
        max={variant.inventory}
        size="small"
      />
    </Group>}
  </ActionsContainer>
}

export default MerchandiseCartReviewTileActions
